import { render, staticRenderFns } from "./HomeInfoSetting.vue?vue&type=template&id=baf1ee3c"
import script from "./HomeInfoSetting.vue?vue&type=script&lang=js"
export * from "./HomeInfoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports